import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'filterCurrencies', pure: true})
export class FilterCurrenciesPipe implements PipeTransform {
  transform(currencies : string[], currencyCode: string): string[] {
    if (currencies && currencyCode) {
      return currencies.filter(c => c !== currencyCode);
    }
    return currencies
  }
}
